import {Component, Input, OnInit} from '@angular/core';
import {UserTagModel} from "../../models/user-tag.model";
import {SpotifyTagsService} from "../../services/spotify-tags-service";

@Component({
  selector: 'app-tags-list',
  templateUrl: './tags-list.component.html',
  styleUrls: ['./tags-list.component.css']
})
export class TagsListComponent implements OnInit {

  @Input() tags: UserTagModel[];

  constructor(private service: SpotifyTagsService) { }

  ngOnInit() {
  }

  navigate() {
    this.service.navigate();
  }


}
